import axios from 'axios'
import {ResponseObject} from '../../../models'
import {ModuleErrorColumn, ModuleModel, ObjectIdModule} from '../features/modules/models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function createModuleService(dto: ModuleModel) {
  return await axios.post<ResponseObject<ModuleModel>>(`${BASEURL}/module/createModule`, dto)
}
export async function editModuleService(dto: ModuleModel) {
  return await axios.put<ResponseObject<ModuleErrorColumn[]>>(`${BASEURL}/module/updateModule`, dto)
}

export async function getModuleByIdService(id: string | undefined | number) {
  return await axios.get<ResponseObject<ModuleModel>>(`${BASEURL}/module/getModuleById`, {
    params: {
      Id: id,
    },
  })
}

export async function deleteModuleService(dto: ObjectIdModule[]) {
  return await axios.delete<ResponseObject<ModuleModel>>(`${BASEURL}/module/deleteModule`, {
    data: dto,
  })
}
